import { useQuery } from '@tanstack/react-query';

import { usePlatformDetect } from '@/hooks/usePlatformDetect';
import { queryFn, getQueryKey } from './queryFn';

type Args = {
  provider: string;
  providerBrokerageId: string | null;
};

export function useGeneratePortfolioLinkToken({
  provider,
  providerBrokerageId,
}: Args) {
  const { status, device } = usePlatformDetect();
  const platform =
    status === 'success' && (device === 'ios' || device === 'android')
      ? device
      : 'browser';

  return useQuery({
    queryKey: getQueryKey(provider, providerBrokerageId, platform),
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: status === 'success',
  });
}
